export default __webpack_public_path__ + "static/media/weather-sun-cloud.9b7f3ca1.webp";